import React, { useState } from "react";
import WorklistSettings from "../../organisms/CollectionSettings";
import { CollectionsDashboard } from "../../organisms/CollectionsDashboard";
import { WidgetConstants } from "../../../utils/common";
import { QARuleForm } from "../../organisms/QARuleForm";
import SettingsDrawer from "../../organisms/SettingsDrawer/SettingsDrawer";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  client: any;
}

const CodingQualitySettings: React.FC<IProps> = ({ isOpen, onClose, client }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [directoryType, setDirectoryType] = useState("");
  const [selected, setSelected] = useState("");

  const showForm = (profile: any, show: boolean) => {
    setSelected(profile);
    setShowDetails(show);
  };

  const caseSamples = () => {
    return (
        <>
          {showDetails ? (
              <QARuleForm
                  directoryType={directoryType}
                  setShowDetails={setShowDetails}
                  client={client}
                  selected={selected}
              />
          ) : (
              <WorklistSettings
                  DirectoryType={directoryType}
                  client={client}
                  setShowDetails={setShowDetails}
                  showForm={showForm}
              />
          )}
        </>
    );
  };

  const getSubtitle = () => {
    return `Settings / ${
        directoryType === "case_samples" ? "Case Samples"
            : directoryType === "coder_samples" ? "Coder Samples"
                : directoryType === "verification_samples" ? "Verification Samples"
                    : "Samples"
    }`;
  };

  return (
      <SettingsDrawer
          isOpen={isOpen}
          onClose={onClose}
          title={WidgetConstants.CODING_QUALITY}
          subtitle={getSubtitle()}
      >
        <CollectionsDashboard
            caseSamples={caseSamples}
            setDirectoryType={setDirectoryType}
            directoryType={directoryType}
            showDetails={showDetails}
            setShowDetails={setShowDetails}
            isQA
            tabs={[
              { label: "Coder Samples", value: "coder_samples" },
              { label: "Case Samples", value: "case_samples" },
              { label: "Verification Samples", value: "verification_samples" },
            ]}
        />
      </SettingsDrawer>
  );
};

export default CodingQualitySettings;
